import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import { usePrevious } from "@sportal/cdk/hooks";

interface TabsSelectStatusProps {
  selected: string;
  ariaStatus?: string;
}

export const TabsSelectStatus = ({
  selected,
  ariaStatus,
}: TabsSelectStatusProps) => {
  const previous = usePrevious(selected);
  const [uniqPrevious, setUniqPrevious] = useState(previous);

  useEffect(() => {
    if (previous !== uniqPrevious && previous !== selected) {
      setUniqPrevious(previous);
    }
  }, [previous, selected, setUniqPrevious, uniqPrevious]);

  if (!uniqPrevious) return null;

  return (
    <div className="sr-only" role="status">
      <FormattedMessage
        id={ariaStatus}
        values={{
          selected: <FormattedMessage id={selected} />,
          previous: <FormattedMessage id={uniqPrevious} />,
        }}
      />
    </div>
  );
};
